import { View } from '../../primitives/View';
import { dotColor } from '../../styles/brand-colors';
import { useTheme } from '../../theme';
import {
  BOTTOM_SHEET_DOT_PITCH_PX,
  BOTTOM_SHEET_DOT_RADIUS_PX,
} from './BottomSheet.variants';

/**
 * Dot-grid fill for `<BottomSheetContent variant="dotted">` — WEB.
 *
 * A CSS `radial-gradient` tiled by `background-size`: it repaints with the
 * element at any size, so there is nothing to measure. The `.native` sibling
 * has to draw an SVG pattern instead, and therefore has to measure.
 *
 * The geometry is the product-wide dot grid — see
 * {@link BOTTOM_SHEET_DOT_PITCH_PX}. This renders the same declaration web's
 * `bg-dotted-pattern` utility does.
 */
export function BottomSheetDottedBackground() {
  const { isDark } = useTheme();
  return (
    <View
      className="absolute inset-0"
      webProps={{
        'aria-hidden': true,
        style: {
          pointerEvents: 'none',
          backgroundImage: `radial-gradient(circle, ${dotColor(isDark)} ${BOTTOM_SHEET_DOT_RADIUS_PX}px, transparent ${BOTTOM_SHEET_DOT_RADIUS_PX}px)`,
          backgroundSize: `${BOTTOM_SHEET_DOT_PITCH_PX}px ${BOTTOM_SHEET_DOT_PITCH_PX}px`,
        },
      }}
    />
  );
}
BottomSheetDottedBackground.displayName = 'BottomSheetDottedBackground';
